











import { ConfigurationEntry } from "@/model/communication/application/GetServerConfigurationResponse";
import { RootState } from "@/store";
import { ApplicationState } from "@/store/modules/ApplicationModule";
import Vue from "vue";
import { mapState } from "vuex";

const maxDaysInactiveKey: string = "caosInactiveHours";

export default Vue.extend({
    props: ["date"],
    computed: {
        ...mapState({
            passwordPolicy: function (state: RootState): ConfigurationEntry[] {
                return (state.application as ApplicationState).configurationEntries.filter((c) => c.section == "OPTIONS");
            },
        }),

        maxDaysInactive() {
            try {
                let value = Number((this.passwordPolicy.find((c: ConfigurationEntry) => c.key == maxDaysInactiveKey) as ConfigurationEntry).value);
                return value >= 0 ? value : Number.MAX_VALUE;
            } catch (error) {
                console.error("Cannot read ", maxDaysInactiveKey, " value from server pw policy configuration. Set it to ", Number.MAX_VALUE, " as default.");
                return Number.MAX_VALUE;
            }
        },

        showAlert() {
            let diff = Math.abs(new Date().getTime() - new Date(this.date).getTime());
            let diffDays = Math.ceil(diff / (1000 * 3600 * 24));
            return diffDays > this.maxDaysInactive;
        },
    },
});
